export default __webpack_public_path__ + "static/media/proj-01-title.f0133e64.png";